<script setup lang="ts">
import { mdiCheck } from "@mdi/js";
import { Ref } from "vue/dist/vue";

interface ICheckbox {
	modelValue: boolean;
	id?: string;
	error?: string | null | undefined | Ref<string>;
	label: string;
	displayLabel?: boolean;
	disabled?: boolean;
	dataId?: string;
	labelStyle?: string;
}

const props = withDefaults(defineProps<ICheckbox>(), {
	id: "",
	displayLabel: true,
	modelValue: false,
	error: null,
	disabled: false,
	dataId: "",
});

const emit = defineEmits(["update:modelValue", "blur", "change"]);

const value = computed({
	get() {
		return props.modelValue;
	},
	set(val) {
		emit("update:modelValue", val);
	},
});

const checkboxID = generatedID(props.label, props.id);
</script>

<template>
	<div class="flex flex-col">
		<div class="inline-flex items-center">
			<label :class="['relative flex items-center rounded-full cursor-pointer', displayLabel !== false && 'mr-2 ']" :for="checkboxID">
				<input
					:data-id="dataId"
					@blur="$emit('blur')"
					@change="$emit('change')"
					:id="checkboxID"
					type="checkbox"
					v-model="value"
					:disabled="disabled"
					:class="[
						'peer relative h-[18px] w-[18px] cursor-pointer appearance-none rounded-sm border-2 border-dark-600 dark:border-light-50  transition-all before:content[\'\'] before:absolute before:top-2/4 before:left-2/4 before:block before:h-10 before:w-10 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:opacity-0 before:transition-opacity checked:before:bg-identity checked:border-identity dark:checked:border-identity checked:bg-identity hover:before:opacity-10 disabled:checked:bg-dark-50 disabled:checked:border-dark-50 dark:disabled:border-dark-50 disabled:hover:before:opacity-0',
						{ 'before:bg-dark-600 dark:before:bg-dark-800': !value },
					]"
				/>
				<span
					class="absolute transition-opacity opacity-0 pointer-events-none peer-checked:opacity-100 top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-light-50"
				>
					<UiIcon class="w-4 h-4 fill-light-50" :path="mdiCheck"> </UiIcon>
				</span>
			</label>
			<label
				v-if="displayLabel !== false"
				:class="[
					labelStyle
						? labelStyle
						: 'flex items-center mt-px text-xs font-light leading-4 cursor-pointer select-none text-dark-600 dark:text-light-50',
				]"
				:for="checkboxID"
			>
				<span v-html="label" /><slot />
			</label>
		</div>

		<p v-if="props.error" :id="`${checkboxID}_help`" class="text-xs pl-9 text-error-600">{{ error }}</p>
	</div>
</template>
